import React from 'react'
import EnergyFields from './EnergyFields'
import { EnergyConsumptions } from '~/api/services/climaCheck'

interface Props {
  energyConsumptions: EnergyConsumptions
}

const TenStep: React.FC<Props> = ({ energyConsumptions }) => {

  return <>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <EnergyFields
        energyConsumptions={energyConsumptions}
      />
    </div>
  </>
}
export default TenStep